import React from "react";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { ArrowDownward } from "@mui/icons-material";
import { useAnalyticsStore } from "./AnalyticsStore/analyticsStore";

export const DownloadButton = () => {
  const { downloadURL } = useAnalyticsStore();

  return (
    <OrangeTextButton
      onClick=""
      text={
        <>
          <ArrowDownward />
          &nbsp;
          <a href={downloadURL} download>
            {downloadURL ? "Download" : "Retrieving Download Data..."}
          </a>
        </>
      }
      disabled={!downloadURL}
    />
  );
};
